import React, { useState, useContext } from 'react';
import 'tailwindcss/tailwind.css';
import axios from 'axios'; // Import Axios
import * as Components from './Components';
import ForgetPassword from 'pages/ForgetPassword';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../helpers/AuthContext';

const SignInUpForm = () => {
    const { login } = useContext(AuthContext);
    const [signIn, toggleSignIn] = useState(true);
    const [forgetPassword, setForgetPassword] = useState(false);
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

  const [signupForm, setSignupForm] = useState({
    name: '',
    mobile: '',
    password: '',
    email: '',
    city: '',
    state: '',
    country: ''
  });

  const [loginForm, setLoginForm] = useState({
    mobile: '',
    password: ''
  });

  const handleSignupChange = (e) => {
    const { name, value } = e.target;
    setSignupForm({
      ...signupForm,
      [name]: value
    });
  };

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginForm({
      ...loginForm,
      [name]: value
    });
  };

    const handleSignupSubmit = async (e) => {
        e.preventDefault();
        try {
          const response = await axios.post(`https://falcon-algo.onrender.com/api/signup`, signupForm);
          setMessage(response.data.message);
          toggleSignIn(true);
        } catch (error) {
          setMessage(error.response ? error.response.data.message : 'Sign up failed');
        }
      };
    
      const handleLoginSubmit = async (e) => {
        e.preventDefault();
        try {
          const success = await login(loginForm);
          if (success) {
            setMessage('Sign in successful');
            navigate('/layout/dashboard');
          } else {
            setMessage('Sign in failed');
          }
        } catch (error) {
          setMessage(error.response ? error.response.data.message : 'Sign in failed');
        }
      };
      
      

  return (
    <Components.CenteringWrapper>
      <Components.Container>
        {forgetPassword ? (
          <Components.FullPageOverlay>
            <ForgetPassword />
            <Components.GhostButton onClick={() => setForgetPassword(false)}>
              Cancel
            </Components.GhostButton>
          </Components.FullPageOverlay>
        ) : (
          <>
            {signIn ? (
              <Components.SignInContainer signinIn={signIn}>
                <Components.Form onSubmit={handleLoginSubmit}>
                  <Components.Title>Sign in</Components.Title>
                  <Components.Input
                    type='tel'
                    name='mobile'
                    placeholder='Mobile'
                    value={loginForm.mobile}
                    onChange={handleLoginChange}
                    required // Built-in validation
                  />
                  <Components.Input
                    type='password'
                    name='password'
                    placeholder='Password'
                    value={loginForm.password}
                    onChange={handleLoginChange}
                    required // Built-in validation
                  />
                  <Components.Anchor href='/forgot-password' onClick={() => setForgetPassword(true)}>
                    Forgot your password? Click here!
                  </Components.Anchor>
                  <Components.Button type='submit'>Sign In</Components.Button>
                  {message && <p>{message}</p>}
                </Components.Form>
              </Components.SignInContainer>
            ) : (
              <Components.SignUpContainer signinIn={signIn}>
                <Components.Form onSubmit={handleSignupSubmit}>
                  <Components.Title>Create Account</Components.Title>
                  <Components.Input
                    type='text'
                    name='name'
                    placeholder='Name'
                    value={signupForm.name}
                    onChange={handleSignupChange}
                    required // Built-in validation
                  />
                  <Components.Input
                    type='tel'
                    name='mobile'
                    placeholder='Mobile'
                    value={signupForm.mobile}
                    onChange={handleSignupChange}
                    pattern='\d{10}' // Custom pattern for 10 digits
                    required // Built-in validation
                  />
                  <Components.Input
                    type='password'
                    name='password'
                    placeholder='Password'
                    value={signupForm.password}
                    onChange={handleSignupChange}
                    minLength={8} // Minimum length
                    required // Built-in validation
                  />
                  <Components.Input
                    type='email'
                    name='email'
                    placeholder='Email'
                    value={signupForm.email}
                    onChange={handleSignupChange}
                    required // Built-in validation
                  />
                  <Components.Input
                    type='text'
                    name='city'
                    placeholder='City'
                    value={signupForm.city}
                    onChange={handleSignupChange}
                    required // Built-in validation
                  />
                  <Components.Input
                    type='text'
                    name='state'
                    placeholder='State'
                    value={signupForm.state}
                    onChange={handleSignupChange}
                    required // Built-in validation
                  />
                  <Components.Input
                    type='text'
                    name='country'
                    placeholder='Country'
                    value={signupForm.country}
                    onChange={handleSignupChange}
                    required // Built-in validation
                  />
                  <Components.Button type='submit'>Sign Up</Components.Button>
                  {message && <p>{message}</p>}
                </Components.Form>
              </Components.SignUpContainer>
            )}
            <Components.OverlayContainer signinIn={signIn}>
              <Components.Overlay signinIn={signIn}>
                <Components.LeftOverlayPanel signinIn={signIn}>
                  <Components.Title>Welcome Back!</Components.Title>
                  <Components.Paragraph>
                    To keep connected with us please login with your personal info
                  </Components.Paragraph>
                  <Components.GhostButton onClick={() => toggleSignIn(true)}>
                    Sign In
                  </Components.GhostButton>
                </Components.LeftOverlayPanel>
                <Components.RightOverlayPanel signinIn={signIn}>
                  <Components.Title>Hello, Friend!</Components.Title>
                  <Components.Paragraph>
                    Enter Your personal details and start the journey with us
                  </Components.Paragraph>
                  <Components.GhostButton onClick={() => toggleSignIn(false)}>
                    Sign Up
                  </Components.GhostButton>
                </Components.RightOverlayPanel>
              </Components.Overlay>
            </Components.OverlayContainer>
          </>
        )}
      </Components.Container>
    </Components.CenteringWrapper>
  );
};

export default SignInUpForm;
